// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multi-section[data-v-52d9b976]{padding-bottom:4px}.addmore-section[data-v-52d9b976]{cursor:pointer;width:-webkit-max-content;width:-moz-max-content;width:max-content;display:flex;align-items:center}.addmore-section .addmore-text[data-v-52d9b976]{padding-left:8px;color:#1253a4;font-weight:bolder;font-size:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
